import React from 'react';
import { Box } from '@material-ui/core';
import ItemTemplateMobile from './ItemTemplateMobile';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import { useRef } from 'react';

const RowContainerMobile = ({
    classes,
    item,
    index,
    editItem,
    editedItemList,
    addSerialNumber,
    lotSerialValueEntered,
    onAccountOwnedSeleted,
    deleteItem,
    displayPrice,
    showBundlefromTableList,
    bundleExpandCollapseIconClickHandler,
    isFromReportScreen,
    vendorCaseErrorRedirection,
    onIsSerialUnknown,
}) => {
    
    return (
        <>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <ItemTemplateMobile
                    classes={classes}
                    item={item}
                    index={index}
                    editItem={editItem}
                    editedItemList={editedItemList}
                    addSerialNumber={addSerialNumber}
                    lotSerialValueEntered={lotSerialValueEntered}
                    onAccountOwnedSeleted={onAccountOwnedSeleted}
                    deleteItem={deleteItem}
                    displayPrice={displayPrice}
                    showBundlefromTableList={showBundlefromTableList}
                    bundleExpandCollapseIconClickHandler={
                        bundleExpandCollapseIconClickHandler
                    }
                    isFromReportScreen={isFromReportScreen}
                    vendorCaseErrorRedirection={vendorCaseErrorRedirection}
                    onIsSerialUnknown={onIsSerialUnknown}
                  
                />
                {item.isBundleExpanded &&
                    item.isBundleItem &&
                    item.children &&
                    item.children.length > 0 &&
                    item.children.map((child, childIdx) => (
                        <Box
                            key={item.index}
                            className={classes.paper}
                            my={1}
                            bgcolor={'#FBFAFF'}
                            boxShadow={'0px 0px 2px #00000029'}
                            borderRadius={6}
                            border={'0.5px solid #F5E2FF'}
                            margin={'10px'}
                        >
                            <ItemTemplateMobile
                                isChildItem
                                classes={classes}
                                item={child}
                                parentIndex={index}
                                index={childIdx}
                                editItem={(editProduct, childIndex) =>
                                    editItem(editProduct, childIndex, index)
                                }
                                editedItemList={(event, editItem, itemIndex) =>
                                    editedItemList(
                                        event,
                                        editItem,
                                        itemIndex,
                                        index
                                    )
                                }
                                addSerialNumber={(product, addItemIndex) =>
                                    addSerialNumber(
                                        product,
                                        addItemIndex,
                                        index
                                    )
                                }
                                lotSerialValueEntered={(
                                    event,
                                    item,
                                    itemIndex,
                                    lotItem,
                                    lotItemIndex
                                ) =>
                                    lotSerialValueEntered(
                                        event,
                                        item,
                                        itemIndex,
                                        lotItem,
                                        lotItemIndex,
                                        undefined,
                                        index
                                    )
                                }
                                onAccountOwnedSeleted={onAccountOwnedSeleted}
                                deleteItem={(id, itemIndex, lotindex) =>
                                    deleteItem(id, itemIndex, lotindex, index)
                                }
                                displayPrice={displayPrice}
                                isFromReportScreen={isFromReportScreen}
                                onIsSerialUnknown={onIsSerialUnknown}
                            />
                        </Box>
                    ))}
                
            </Box>
        </>
    );
};

export default RowContainerMobile;
